// @ts-nocheck

const ERROR_CODE_ACCESS_DENIED = 1;
const ERROR_CODE_BAD_REQUEST = 2;
const ERROR_CODE_MAINTENANCE = 3;
const ERROR_CODE_SAME_BET = 4;

const ERROR_CODE_DB_ERROR = 11;
const ERROR_CODE_NOT_ENOUGH_MONEY = 100;
const ERROR_CODE_ACCOUNT_LOCKED = 150;
const ERROR_CODE_ODDS_CHANGED = 300;
const ERROR_CODE_BET_SUSPENDED = 305;
const ERROR_CODE_BET_STOPPED = 306;
const ERROR_CODE_ODDS_UNDER_LIMIT = 310;
const ERROR_CODE_AMOUNT = 3110; // NOTE: erreur interne client si la mise est à 0
const ERROR_CODE_AMOUNT_UNDER_LIMIT = 311;
const ERROR_CODE_AMOUNT_OVER_LIMIT = 312;
const ERROR_CODE_NEED_MANUAL_VALIDATION = 313;
const ERROR_CODE_MODERATOR_REACHED = 400;
const ERROR_CODE_DAILY_MODERATOR_REACHED = 401;
const ERROR_CODE_WEEKLY_MODERATOR_REACHED = 402;
const ERROR_CODE_MONTHLY_MODERATOR_REACHED = 403;
const ERROR_CODE_LIMITED_TO_FREEBETS = 800;
const ERROR_CODE_TRADER = 900;

export default {
  ERROR_CODE_ACCESS_DENIED,
  ERROR_CODE_BAD_REQUEST,
  ERROR_CODE_MAINTENANCE,
  ERROR_CODE_SAME_BET,
  ERROR_CODE_DB_ERROR,
  ERROR_CODE_NOT_ENOUGH_MONEY,
  ERROR_CODE_ACCOUNT_LOCKED,
  ERROR_CODE_ODDS_CHANGED,
  ERROR_CODE_BET_SUSPENDED,
  ERROR_CODE_BET_STOPPED,
  ERROR_CODE_ODDS_UNDER_LIMIT,
  ERROR_CODE_AMOUNT,
  ERROR_CODE_AMOUNT_UNDER_LIMIT,
  ERROR_CODE_AMOUNT_OVER_LIMIT,
  ERROR_CODE_NEED_MANUAL_VALIDATION,
  ERROR_CODE_MODERATOR_REACHED,
  ERROR_CODE_DAILY_MODERATOR_REACHED,
  ERROR_CODE_WEEKLY_MODERATOR_REACHED,
  ERROR_CODE_MONTHLY_MODERATOR_REACHED,
  ERROR_CODE_LIMITED_TO_FREEBETS,
  ERROR_CODE_TRADER,
};
